import type { SpreadReadingProfile } from "../types";

export const crossChoiceReadingProfile: SpreadReadingProfile = {
  spreadId: "spread_cross_choice",
  sections: [
    {
      id: "mainMeaning",
      title: "Основной смысл",
      source: { type: "keywords" },
    },
    {
      id: "questionContext",
      title: "В контексте вопроса",
      source: { type: "uprightByQuestionContext" },
    },
    {
      id: "psychology",
      title: "Психологический аспект",
      source: { type: "psychology" },
    },
  ],
};

